export type EbitdaAddbackGroup = 'interest' | 'taxes' | 'depreciation' | 'amortization'

type StatementAccount = {
  statement_type?: string | null
  label?: string | null
  qbo_account_type?: string | null
  qbo_account_sub_type?: string | null
  qbo_classification?: string | null
  normal_balance?: string | null
}
const token = (value: unknown) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()

/** Classification shared by Financials and presentation exports. */
export function ebitdaAddbackGroup(row: StatementAccount): EbitdaAddbackGroup | null {
  if (row.statement_type !== 'profit_and_loss') return null
  const classification = token(row.qbo_classification)
  if (['asset', 'liability', 'equity', 'revenue', 'income'].includes(classification)) return null
  const accountType = token(row.qbo_account_type)
  const text = token([row.qbo_account_type, row.qbo_account_sub_type, row.qbo_classification, row.label].filter(Boolean).join(' '))
  const expenseLike = /expense|cost/.test(accountType) || /expense|cost/.test(classification)
    || (!accountType && !classification && (row.normal_balance === 'debit' || /expense|cost/.test(text)))
  if (!expenseLike) return null
  if (text.includes('amortization')) return 'amortization'
  if (text.includes('depreciation')) return 'depreciation'
  if (!text.includes('interest income') && /\binterest\b/.test(text)) return 'interest'
  if (['income tax', 'tax expense', 'corporate tax', 'federal tax', 'state tax'].some((name) => text.includes(name))
    && !['payroll', 'sales tax', 'property tax', 'tax payable'].some((name) => text.includes(name))) return 'taxes'
  return null
}
